import { Paper } from '@mui/material';
import { Redirect } from 'react-router-dom';
import { useStoreState } from '~/store/hooks';

import styles from './SignInMfa.module.scss';
import VerifyCode from './VerifyCode';
import { SIGN_IN } from '~/ui/constants/paths';

const SignInMfa = () => {
  const isMfaRequired = useStoreState(store => store.auth.isMfaRequired);

  if (!isMfaRequired) {
    return <Redirect to={SIGN_IN} />;
  }

  return (
    <Paper elevation={3} className={styles.container}>
      <VerifyCode />
    </Paper>
  );
};

export default SignInMfa;
